import { render, staticRenderFns } from "./IconMagicPen.vue?vue&type=template&id=222c4199"
import script from "./IconMagicPen.vue?vue&type=script&lang=js"
export * from "./IconMagicPen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports